import React from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import Loading from '../../pages/Loading/Loading';

const CategoriesItem = () => {

    const navigate = useNavigate();

    const redirectToCategoriesProducts = (categoryId) => {
        navigate(`/categories-products/${categoryId}`);
    };

    const { data, isLoading} = useQuery("categoryMenu", () => fetch("https://wehatbazar.thecell.tech/api/category", {
        method: "GET",
        headers: {
            'content-type': "application/json",
            "X-Requested-With": "XMLHttpRequest",
            'authorization': `Bearer ${localStorage.getItem('token')}`
        }
    }).then((res) => res.json()
    )
    )

    if(isLoading) {
        return <Loading></Loading>
    }





    const category = data?.data

    

    return (
        <div className="text-white overflow-hidden grid bg-inherit lg:grid-cols-6 sm:gird-cols-1 gap-4 lg:bg-[#7811D4]">
            {category.map(item => (
                    <button key={item.id} onClick={() => redirectToCategoriesProducts(item?.id)} className='truncate m-2'>{item?.name}</button>
            ))}
            {/* {displayCount < category.length && (
                <button className=' btn py-2 px-2 text-white font-semibold' onClick={handleShowMore}>Show More</button>
            )} */}
        </div>
    );
};

export default CategoriesItem;